@if (data$ | async; as component) {
  <div class="vertical-selection-container">
    @switch (component.titleTag) {
      @case ('H1') {
        <h1
          class="h2-component title"
          [style.color]="component.titleColor"
          [style.font-size]="component.titleSize"
          [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
          >
          {{component.title}}
        </h1>
      }
      @case ('H2') {
        <h2
          class="h2-component title"
          [style.color]="component.titleColor"
          [style.font-size]="component.titleSize"
          [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
          >
          {{component.title}}
        </h2>
      }
      @default {
        <div
          class="h2-component title"
          [style.color]="component.titleColor"
          [style.font-size]="component.titleSize"
          [style.font-weight]="component.titleBold === 'true' ? 'bold' : '400'"
          >
          {{component.title}}
        </div>
      }
    }
    <div class="images-container">
      <div class="image-item left-image">
        <app-custom-ohgar-text-static-banner [item]="component.image1"></app-custom-ohgar-text-static-banner>
      </div>
      <div class="image-item right-image">
        <app-custom-ohgar-text-static-banner [item]="component.image2"></app-custom-ohgar-text-static-banner>
      </div>
    </div>
  </div>
}
